import { OrgMemberRole } from './org-member';

export enum ManageMembersView {
  NODE_ACCESS,
  INVITE,
  ORG_ACCESS_LIST,
}

export enum ManageMembersType {
  PORTAL_NODE,
  PORTAL,
  WORKSPACE,
}

export interface ManageMembersContext {
  workspaceId: string;
  orgId: string;
  portalUrl: string;
  portalId?: string;
}

export interface ManageMembersOrgLimits {
  membersPerOrg: number;
  guests: number;
}

export interface GetManageMembersDataProps {
  orgId: string;
  workspaceId: string;
}

export interface ManageMembersInvite {
  email: string;
  role: string;
  orgRole?: OrgMemberRole;
  isFullAccess: boolean;
}
export interface ManageMembersInvitePayload {
  workspaceId: string;
  portalUrl: string;
  portalId?: string;
  invites?: ManageMembersInvite[];
  deleteIds?: string[];
}
